export default "__VITE_ASSET__C7xpCe8Z__"